import Immutable from 'seamless-immutable';

import { get, remove, set } from 'js-cookie';
import { Cookie } from 'next-cookie';

import EXPIRES_COOKIES from '../../libs/cookies';

// <-------------------- CART-ID --------------------> \\

/**
 * Salva o id do carrinho nos cookies.
 *
 * @param {String} cartId id do usuário.
 */
// eslint-disable-next-line no-unused-vars
export function setCartId(cartId, domain) {
  if (cartId)
    set('cart.id', cartId, {
      expires: EXPIRES_COOKIES,
      // domain,
      path: '/',
    });
}

/**
 * Busca o id do carrinho nos cookies.
 *
 * @returns {String} retorna o id do carrinho.
 */
// eslint-disable-next-line no-unused-vars
export function getCartId(domain) {
  // const cartId = get('cart.id', { domain });
  return get('cart.id');
}

/**
 * Busca o cookie de indentifiação de lead na sessão
 *
 * @returns {Boolean} retorna se a sessão é de um lead.
 */
// eslint-disable-next-line no-unused-vars
export function getLeadCookie(domain) {
  // const leadPhone = get('lead.setted-phone', { domain });
  return get('lead.setted-phone');
}

/**
 * Remove o id do carrinho dos cookies.
 */
// eslint-disable-next-line no-unused-vars
export function removeCartId(domain) {
  remove('cart.id', {
    // domain,
    path: '/',
  });
}

// <-------------------- CUSTOMER-CEP ----------------------> \\

/**
 * Salva o CEP do usuário nos cookies.
 *
 * @param {String} cep CEP do usuário.
 */
// eslint-disable-next-line no-unused-vars
export function setCustomerCep(cep, domain) {
  if (cep)
    set('customer.cep', cep, {
      expires: EXPIRES_COOKIES,
      // domain,
      path: '/',
    });
}

/**
 * Busca o CEP nos cookies.
 *
 * @returns {String} retorna o CEP so usuário.
 */
// eslint-disable-next-line no-unused-vars
export function getCustomerCep(domain) {
  // const cep = get('customer.cep', { domain });
  return get('customer.cep');
}

/**
 *
 * Remove o CEP do usuário dos cookies.
 */
// eslint-disable-next-line no-unused-vars
export function removeCustomerCep(domain) {
  remove('customer.cep', {
    // domain,
    path: '/',
  });
}

// <--------------------- LAST-PURCHASE --------------------> \\

/**
 * Salva o Id da última transação do cliente nos cookies.
 *
 * * @param {String} id Id do pedido.
 */
// eslint-disable-next-line no-unused-vars
export function setLastPurchase(id, domain) {
  if (id)
    set('customer.last.purchase', id, {
      expires: EXPIRES_COOKIES,
      // domain,
      path: '/',
    });
}
/**
 *
 * @returns {String} retorna o Id do último pedido do usuário.
 */
// eslint-disable-next-line no-unused-vars
export function getLastPurchase(domain) {
  // const lastPurchase = get('customer.last.purchase', { domain });
  return get('customer.last.purchase');
}
/**
 * Salva o Id da última transação do cliente nos cookies.
 */
// eslint-disable-next-line no-unused-vars
export function removeLastPurchase(domain) {
  remove('customer.last.purchase', {
    // domain,
    path: '/',
  });
}

/**
 * Método generico para buscar cookie server/client
 */
export function getCookie(...args) {
  const state = Immutable(args[0] || {});
  const { name, ctx = null } = args[1] || {};

  if (ctx) {
    return new Cookie(ctx).get(name);
  }

  return get(name, { domain: args[2] }) || state.getIn([...name.split('.').map((item) => [item])]) || null;
}

/**
 * Método generico para setar cookie server/client
 */
export function setCookie(name, value, ctx = null, options = {}) {
  const newOptions = {
    ...options,
    domain: undefined,
  };
  if (ctx) {
    return new Cookie(ctx).set(name, value, { ...newOptions, expires: EXPIRES_COOKIES, path: '/' });
  }

  return set(name, value, { ...newOptions, expires: EXPIRES_COOKIES, path: '/' });
}
